import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Text } from 'onefaceui-react-components';

import Phone1Icon from 'static/images/phone-1.svg';
import Phone2Icon from 'static/images/phone-2.svg';

/**
 * Component to display location information
 * Single responsibility: Display location details including address and phones
 */
const LocationInfoDisplay = ({ location, address, phones }) => {
  return (
    <>
      <Flex flexDirection="column">
        <Text size="sm" weight="bold">
          {location?.key} - {location?.description}
        </Text>
        {address && (
          <Text className="address-text" size="xs">
            {address}
          </Text>
        )}
      </Flex>
      
      {phones && phones.length > 0 && (
        <Flex alignItems="center" gap={22}>
          {phones.map(({ phone, phoneIcon }) => (
            <Flex alignItems="center" gap={4} key={phone}>
              {phoneIcon}
              <Text size="xs" weight="medium">
                {phone}
              </Text>
            </Flex>
          ))}
        </Flex>
      )}
    </>
  );
};

export const getPhones = (location) => {
  let phones = [];

  const phoneIcons = [
    <img key={1} className="phone-icon" src={Phone1Icon} alt="Phone 1" />,
    <img key={2} className="phone-icon" src={Phone2Icon} alt="Phone 2" />
  ];

  if (location?.phone1) {
    phones.push(location.phone1);
  }

  if (location?.phone2) {
    phones.push(location.phone2);
  }

  phones = phones.map((phone, i) => ({ phone, phoneIcon: phoneIcons[i] }));

  return phones;
};

export const getAddress = (location) => {
  if (!location) return '';
  
  const addressItems = [];

  const keyValidToAddress = (key) => {
    const validAddresses = [
      'addressLine1',
      'addressLine2',
      'district',
      'city',
      'state',
      'country',
      'zipCode'
    ];

    return validAddresses.indexOf(key) !== -1;
  };

  for (let key in location) {
    if (keyValidToAddress(key) && location[key]) {
      addressItems.push(location[key]);
    }
  }
  return addressItems.filter((item) => item).join(', ');
};

LocationInfoDisplay.propTypes = {
  location: PropTypes.shape({
    key: PropTypes.string,
    description: PropTypes.string,
    phone1: PropTypes.string,
    phone2: PropTypes.string
  }),
  address: PropTypes.string,
  phones: PropTypes.arrayOf(
    PropTypes.shape({
      phone: PropTypes.string.isRequired,
      phoneIcon: PropTypes.node.isRequired
    })
  )
};

LocationInfoDisplay.defaultProps = {
  location: null,
  address: '',
  phones: []
};

export default LocationInfoDisplay;
